import { BrandName } from '@seek/je-shared-data/lib/types/brand';

/**
 * Determines whether to show the benefit for job featured for 28 days.
 *
 * @param {BrandName} params.brand - The brand name.
 * @returns {boolean} Returns true if the benefit should be shown, otherwise
 * false.
 */
export const showJobFeaturedForXDays = ({
  brand
}: {
  brand: BrandName;
}): boolean => {
  if (brand === BrandName.JOBSDB) return true;
  if (brand === BrandName.JORA) return true;

  return false;
};
